export const parseArquivoAdditions = (additions) => {
  if (additions == null || additions === '') return null;
  if (typeof additions === 'object') return additions;
  if (typeof additions !== 'string') return null;
  try {
    const parsed = JSON.parse(additions);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

export const formatEvidenciaGpsCaption = (additions) => {
  const data = parseArquivoAdditions(additions);
  if (!data) return null;

  const parts = [];
  const endereco = data.enderecoShow
    ? String(data.enderecoShow).replace(/\n/g, ', ')
    : data.endereco;
  if (endereco) parts.push(endereco);
  if (data.latitude != null && data.longitude != null) {
    parts.push(`${data.latitude} / ${data.longitude}`);
  }
  if (data.precisao != null && data.precisao !== '') {
    parts.push(`precisão ${data.precisao} m`);
  }

  return parts.length > 0 ? parts.join(' · ') : null;
};

export const isArquivoCarimbada = (additions) => {
  const data = parseArquivoAdditions(additions);
  return data?.carimbada === true || data?.carimbada === 'true';
};
